import Exception from './Exception';
/**
 * Custom Error class of type Exception.
 */
export default class FormatException extends Exception {
    static getFormatInstance() {
        return new FormatException();
    }
}
FormatException.kind = 'FormatException';
//# sourceMappingURL=FormatException.js.map